// extracted by css-extract-rspack-plugin
export default {"skeleton":"jcaFT9Eg64YBxIqU","row":"GLGShih9IKoQs1lP","pulse":"G1YxG8Zs9AYUynjH"};